export default "__VITE_ASSET__Bc4gW9BD__"